export const AUTH_STACK = {
  LOGIN_OPTIONS: "/login",
  LOGIN_WITH_EMAIL: "/login/email",
  LOGIN_WITH_MOBILE: "/login/mobile",
  FORGOT_PASSWORD_WITH_EMAIL: "/forgot-password",
  FORGOT_PASSWORD_WITH_MOBILE: "/forgot-password/mobile",
  RESET_PASSWORD_WITH_EMAIL: "/reset-password/email",
  UPDATE_PASSWORD: "/update-password",
  PERSONAL_DETAILS: "/signup/personal-details",
  LOCATION_DETAILS: "/signup/location-details",
  ORGANISATION_DETAILS: "/signup/organisation-details",
  RESET_PASSWORD_WITH_MOBILE: "/reset-password/mobile",
  SIGNUP_OPTIONS: "/signup",
  SIGNUP_WITH_EMAIL: "/signup/email",
  SIGNUP_VERIFY: "/signup/verify",
  // SIGNUP_DETAILS: "/signup/details",
  // SIGNUP_LOCATION: "/signup/location",
};

export const DASHBOARD_STACK = {
  HOME: "/",
  MEMBERS: "/members",
  NOTIFICATIONS: "/notifications",
  TEAM_OVERVIEW: "/members/team-overview/:teamId",
  FIXTURES: "/fixtures",
  PAYMENTS: "/payments",
  PAYMENT_DETAILS: "/payments/payment-details/:id",
  STRIPE_CONNECT_RETURN: "/payments/stripe-connect/return",
  STRIPE_CONNECT_REFRESH: "/payments/stripe-connect/refresh",
  RESULTS: "/results",
  STATISTICS: "/statistics",
  STANDINGS: "/standings",
  FORMAT: "/format",
  MANUALGRID: "/format/manual",
  ORGANISATION_MEMBERS: "/organisation-members",
  SETTINGS: "/settings",
  ORGANISATION: "/organisation",
  PUBLIC_VIEW: "/public/:tournamentId",
  COMPETITIONS: "/competitions/new",
  COMPETITIONS_CONFIG: "/competition/config",
  COMPETITIONS_VENUE: "/competition/venue",
  COMPETITIONS_FEE: "/competition/registration-fee",
  CREATE_TOURNAMENT: {
    TOURNAMENT_NAME: "/create-tournament/tournament-name",
    TOURNAMENT_LOGO: "/create-tournament/tournament-logo",
    CHOOSE_SPORT: "/create-tournament/choose-sport",
    CHOOSE_TOURNAMENT: "/create-tournament/choose-tournament",
    CHOOSE_DURATION_TYPE: "/create-tournament/choose-duration-type",
    CHOOSE_VENUE_TYPE: "/create-tournament/choose-venue-type",
    CHOOSE_RESULT_MANAGEMENT: "/create-tournament/choose-result-management",
    SET_MATCH_RULES: "/create-tournament/set-match-rules",
    SET_MATCH_SCHEDULE: "/create-tournament/set-match-schedule",
    CREATE_TOURNAMENT_DIVISION: "/create-tournament/create-tournament-division",
    DIVISION_TEAM: "/create-tournament/division-team",
    TEAM_REGISTRATION_FEE: "/create-tournament/team-registration-fee",
    CREATE_TOURNAMENT_SEASON: "/create-tournament/create-tournament-season",
    CREATE_TOURNAMENT_TEAM_COUNT:
      "/create-tournament/create-tournament-team-count",
    CREATE_TOURNAMENT_GROUPS: "/create-tournament/create-tournament-groups",
  },
  ORGANISATIONS: "/organisations",
  EDIT_PROFILE: "/profile/edit",
  EDIT_COMPETITION: "/competition/edit",
};
